<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Verificacion de reglas de Alias Manuales'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='false'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="formulario" novalidate class="form-group">
          
          <!-- Búsqueda de Empleado -->
          <div class="row">
            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="cedula" [label]="'* Ingrese cédula'" [id]="'cedula'" 
                [control]="formulario.get('cedula')" [placeholder]="'Ingrese Cédula del Empleado'" 
                (change)="getEmpleado($event)" [type]="'text'">
              </app-lfsa-input>
            </div>

            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="nombres" [label]="'Nombre Empleado'" [id]="'nombres'" 
                [control]="formulario.get('nombres')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>

            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="apellidoParterno" [label]="'Apellido Parterno'" [id]="'apellidoParterno'" 
                [control]="formulario.get('apellidoParterno')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>

            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="apellidomaterno" [label]="'Apellido Materno'" [id]="'apellidomaterno'" 
                [control]="formulario.get('apellidomaterno')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
          </div>

          <div class="row">
            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="codEmpleado" [label]="'Código Empleado'" [id]="'codEmpleado'" 
                [control]="formulario.get('codEmpleado')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>

            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="codigoBp" [label]="'Código BP'" [id]="'codigoBp'" 
                [control]="formulario.get('codigoBp')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>

            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="dscaLocalidad" [label]="'Localidad'" [id]="'dscaLocalidad'" 
                [control]="formulario.get('dscaLocalidad')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>

            <div [class]="'col-md-3'">
              <app-lfsa-input formControlName="statusEmpleado" [label]="'Estado'" [id]="'statusEmpleado'" 
                [control]="formulario.get('statusEmpleado')" [type]="'text'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
          </div>


          <!-- Botón de Acción -->
          <div class="row">
            <div [class]="'col-md-12'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-success btn-block" [disabled]="formulario.get('cedula').invalid"
                  (click)="consultarAlias()">Ver opciones de alias</button>
              </div>
            </div>
          </div>

          <!-- Grid de Resultados -->
          <div class="row" *ngIf="rowData.length > 0">
            <div class="col-md-12">
              <br>
              <h5>Posibles Alias del Empleado</h5>
              <hr>
              <div class="form-group">
                <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar" 
                  [ngModelOptions]="{standalone: true}" id="quickFilter" (keyup)="onQuickFilterChanged()" #quickFilter />
              </div>
              <br>
              <ag-grid-angular #agGrid class="{{seguridadDAModulo.agGrid.class}}" 
                [ngStyle]="seguridadDAModulo.agGrid.style"
                id="{{seguridadDAModulo.agGrid.id}}" 
                [frameworkComponents]="frameworkComponents"
                [columnDefs]="columnDefs" 
                [rowSelection]="rowSelection" 
                [rowData]="rowData"
                (gridReady)="onGridReady($event)" 
                [pagination]="true">
              </ag-grid-angular>
            </div>
          </div>

        </form>
      </div>
    </div>
  </ng-template>
</div>
